import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICostumUdf, IUdfValue } from '@app/interfaces/i-udf';
import { Structures } from '@clavisco/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomUdfPresentationService {

  constructor(private http: HttpClient) { }

  /**
   * Obtiene los Udfs configurados
   * @param _apiUrl URL del API
   * @param _category Categoria del los UDFs a consultar. Ej: OINV, ORDR, OQUT...
   * @param _group Grupo de udfs que se desea consultar
   * @constructor
   */
  GetUdfs(_apiUrl: string, _category: string, _group: string): Observable<Structures.Interfaces.ICLResponse<ICostumUdf[]>>
  {
    return this.http.get<Structures.Interfaces.ICLResponse<ICostumUdf[]>>(`api/Udfs`,{
      params: {
        Category: _category,
        IsUdfLine: false,
        Configured: true,
        Group: _group
      }
    });
  }


  /**
   * Consulta los valores de un UDF en base al valor de otro UDF
   * @param _dbo Nombre del procedimiento almacenado o funcion
   * @param _value Valor seleccionado del UDF base
   * @param _dboType Tipo de objeto de base de datos FN | SP
   * @param _apiUrl Url del API
   * @constructor
   */
  GetUdfValueByDBO(_dbo: string, _value: string, _dboType: string, _apiUrl: string): Observable<Structures.Interfaces.ICLResponse<IUdfValue[]>> {

    return this.http.get<Structures.Interfaces.ICLResponse<IUdfValue[]>>(`api/Udfs`, {
      params: {
        Dbo: _dbo,
        Value: _value,
        DboType: _dboType
      }
    });
  }
}
